import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./scss/PageNotFound.scss";

import logo from "../images/logo.png";

const PageNotFound = () => {
  const { t } = useTranslation();
  document.title = "Gudema 404";

  return (
    <main className="not-found-page">
      <section className="not-found">
        <div className="not-found__card">
          <div className="not-found__flower" />

          <div className="not-found__content">
            <img src={logo} alt="Gudema" className="not-found__logo" />

            <div className="not-found__number">404</div>

            <h1>{t("notFound.title")}</h1>

            <p>{t("notFound.text")}</p>

            <div className="not-found__actions">
              <Link to="/" className="not-found__btn not-found__btn--primary">
                {t("notFound.home")}
              </Link>

              <Link to="/shop" className="not-found__btn not-found__btn--outline">
                {t("notFound.shop")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PageNotFound;
